import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { PRIORITY_OPTIONS } from '../lib/priority';

const inputClass = 'w-full min-w-0 rounded-md border bg-white px-3 py-2 text-sm';
export const WorkOrderFindingsFields = ({ value, onChange, disabled = false }) => {
  const change = (id, patch) => onChange(value.map((f) => f.id === id ? { ...f, ...patch } : f));
  return <section className="space-y-3 min-w-0 border-t pt-4" data-testid="wo-findings-fields">
    <div className="flex flex-wrap justify-between items-center gap-2">
      <h3 className="text-sm font-semibold">Findings & follow-ups</h3>
      <Button type="button" size="sm" variant="outline" data-testid="wo-add-finding-btn" disabled={disabled || value.length >= 50}
        onClick={() => onChange([...value, { id: crypto.randomUUID(), description: '', disposition: 'recorded',
          action_notes: '', follow_up_kind: 'minor', priority: 'p2', due_date: null }])}><Plus size={14} className="mr-1" /> Add finding</Button>
    </div>
    {value.map((f, index) => <fieldset key={f.id} disabled={disabled} className="space-y-3 min-w-0 border-l-2 border-slate-200 pl-3 py-2" data-testid={`wo-finding-${index}`}>
      <div className="flex justify-between items-center gap-2">
        <Label htmlFor={`wo-finding-description-${index}`}>Finding {index + 1} *</Label>
        <Button type="button" size="icon" variant="ghost" className="h-8 w-8" aria-label={`Remove finding ${index + 1}`}
          title="Remove finding" data-testid={`wo-remove-finding-${index}`} onClick={() => onChange(value.filter((row) => row.id !== f.id))}><Trash2 size={14} /></Button>
      </div>
      <Textarea id={`wo-finding-description-${index}`} data-testid={`wo-finding-description-${index}`} rows={2}
        value={f.description} required maxLength={5000} onChange={(e) => change(f.id, { description: e.target.value })}
        placeholder="e.g., Two lower distance-piece mounting bolts found loose" />
      <div className="space-y-1">
        <Label htmlFor={`wo-finding-disposition-${index}`}>Finding outcome</Label>
        <select id={`wo-finding-disposition-${index}`} data-testid={`wo-finding-disposition-${index}`} className={inputClass}
          value={f.disposition} onChange={(e) => change(f.id, { disposition: e.target.value })}>
          <option value="recorded">Recorded only — no tracked follow-up</option>
          <option value="addressed">Addressed during this service</option>
          <option value="follow_up">Follow-up required</option>
        </select>
      </div>
      <div className="space-y-1">
        <Label htmlFor={`wo-finding-notes-${index}`}>{f.disposition === 'follow_up' ? 'Next action / notes' : 'Action taken / notes'}</Label>
        <Textarea id={`wo-finding-notes-${index}`} data-testid={`wo-finding-notes-${index}`} rows={2} maxLength={5000}
          value={f.action_notes} onChange={(e) => change(f.id, { action_notes: e.target.value })} />
      </div>
      {f.disposition === 'follow_up' && <div className="space-y-3">
        <div className="space-y-1">
          <Label htmlFor={`wo-finding-kind-${index}`}>Track as</Label>
          <select id={`wo-finding-kind-${index}`} data-testid={`wo-finding-kind-${index}`} className={inputClass}
            value={f.follow_up_kind} onChange={(e) => change(f.id, { follow_up_kind: e.target.value })}>
            <option value="minor">Tracked follow-up</option><option value="work_order">New linked work order</option>
          </select>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div className="space-y-1"><Label htmlFor={`wo-finding-priority-${index}`}>Priority</Label>
            <select id={`wo-finding-priority-${index}`} data-testid={`wo-finding-priority-${index}`} value={f.priority}
              className={inputClass} onChange={(e) => change(f.id, { priority: e.target.value })}>
              {PRIORITY_OPTIONS.map((p) => <option key={p.value} value={p.value}>{p.label}</option>)}
            </select>
          </div>
          <div className="space-y-1"><Label htmlFor={`wo-finding-due-${index}`}>Due date (optional)</Label>
            <Input id={`wo-finding-due-${index}`} data-testid={`wo-finding-due-${index}`} type="date"
              value={f.due_date || ''} onChange={(e) => change(f.id, { due_date: e.target.value || null })} />
          </div>
        </div>
      </div>}
    </fieldset>)}
  </section>;
};